import React, { useContext, useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import { UserContext } from "../../context/UserContext";
import { Spinner, Table, Button, Form, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import * as Icon from "react-bootstrap-icons";

const WithDrawal = () => {
  const auth = useContext(UserContext);
  const [toggleValue, setToggleValue] = useState(false);
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [amount, setAmount] = useState("");
  const [error, setError] = useState(null);
  const [showActionModal, setShowActionModal] = useState(false);
  const [actionType, setActionType] = useState(""); // "approve" or "reject"
  const [selectedWithdrawalId, setSelectedWithdrawalId] = useState(null);
  const [actionComment, setActionComment] = useState("");

  // Fetch token from localStorage
  const token = localStorage.getItem("token");

  // Fetch all withdrawals if the user is admin, user, or distributor
  const fetchWithdrawals = async () => {
    try {
      let response = await axios.get(
        `${process.env.REACT_APP_API_URL}userinfo/all-withdrawals`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include token in the request header
          },
          params: { userId: auth?.user?.id },
        }
      );

      setWithdrawals(response.data);
    } catch (error) {
      console.error("Error fetching withdrawals:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    setLoading(true);
    fetchWithdrawals();
  }, [auth?.user?.userType, auth?.user?.id, token]);

  const handleAmountChange = (e) => {
    setAmount(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate the input amount
    if (!amount || isNaN(amount) || amount <= 0) {
      setError("Please enter a valid amount.");
      return;
    }

    setError(null);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}userinfo/requestwithdrawal`,
        {
          name: auth?.user?.name,
          email: auth?.user?.email,
          amount: parseFloat(amount),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include token in the request header
          },
        }
      );

      // Optionally update the withdrawals list with the new request
      setWithdrawals((prevWithdrawals) => [...prevWithdrawals, response.data]);
      setAmount(""); // Clear the input after successful submission
      toast.success("Withdrawal request submitted successfully!");
      fetchWithdrawals();
    } catch (error) {
      console.error("Error creating withdrawal:", error);
      setError(error.response.data.message);
      toast.error(error.response.data.message);
    }
  };

  const handleActionSubmit = async () => {
    const permission = actionType === "approve" ? 1 : 2;

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}userinfo/update-permission`,
        {
          id: selectedWithdrawalId,
          permission_for_request: permission,
          reasonForPermission: actionComment, // Send reason to backend
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setWithdrawals((prev) =>
        prev.map((w) =>
          w.id === selectedWithdrawalId
            ? { ...w, permission_for_request: permission }
            : w
        )
      );

      toast.success(
        response.data.message ||
        `Withdrawal ${actionType === "approve" ? "approved" : "rejected"}`
      );
      await fetchWithdrawals();
    } catch (error) {
      toast.error("Action failed. Try again.");
      console.error(error);
    } finally {
      setShowActionModal(false);
      setSelectedWithdrawalId(null);
      setActionComment("");
      setActionType("");
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-2 p-0">
          <Sidebar
            toggleSidebar={toggleValue}
            setToggleValue={setToggleValue}
          />
        </div>
        <div className="col-lg-10 p-lg-5 p-md-4 mt-lg-5 mt-md-3 mt-3 dashboard-wrapper">
          {/* Render only if user is admin or user/distributor */}
          {auth?.user?.userType === "admin" ? (
            <div className="withdrawals-table">
              <div className="mb-4">
                <h5>All Withdrawal</h5>
                <h6 className="text-muted">View all Withdrawal requests</h6>
              </div>
              <Table striped bordered hover responsive="sm">
                <thead className="text-center">
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Date</th>
                    <th>Amount</th>
                    <th>Reason/Remark</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="5" className="text-center p-5">
                        <Spinner animation="border" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </Spinner>
                      </td>
                    </tr>
                  ) : withdrawals.length > 0 ? (
                    withdrawals.map((withdrawal, i) => (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{withdrawal.name}</td>
                        <td>
                          {new Date(withdrawal.timestamp).toLocaleDateString(
                            "en-CA"
                          )}
                        </td>
                        <td><Icon.CurrencyRupee />{withdrawal.amount}</td>
                        <td>{withdrawal.reasonForPermission}</td>
                        <td className="text-center">
                          {
                            withdrawal.permission_for_request === 0 || withdrawal.permission_for_request === 1
                              ?
                              <button
                                className={`btn btn-success ${withdrawal.permission_for_request === 1 ? '' : 'me-2'}`}
                                style={{ width: "100px" }}
                                disabled={withdrawal.permission_for_request !== 0}
                                onClick={() => {
                                  setActionType("approve");
                                  setSelectedWithdrawalId(withdrawal.id);
                                  setShowActionModal(true);
                                }}
                              >
                                Approve
                              </button>
                              :
                              ""
                          }
                          {
                            withdrawal.permission_for_request === 0 || withdrawal.permission_for_request === 2
                              ?
                              <button
                                className="btn btn-danger"
                                style={{ width: "100px" }}
                                disabled={withdrawal.permission_for_request !== 0}
                                onClick={() => {
                                  setActionType("reject");
                                  setSelectedWithdrawalId(withdrawal.id);
                                  setShowActionModal(true);
                                }}
                              >
                                Reject
                              </button>
                              :
                              ""
                          }
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center p-5">
                        No recent withdrawal requests
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          ) : (
            <div>
              <h4>Your Withdrawal Requests</h4>
              <Table striped bordered hover responsive="sm">
                <thead className='text-center'>
                  <tr>
                    <th>ID</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Reason</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="4" className="text-center p-5">
                        <Spinner animation="border" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </Spinner>
                      </td>
                    </tr>
                  ) : withdrawals.length > 0 ? (
                    withdrawals.map((withdrawal, i) => (
                      <tr key={i}>
                        <td>{withdrawal.id}</td>
                        <td>{withdrawal.amount}</td>
                        <td>
                          {withdrawal.permission_for_request === 0
                            ? "Under Review"
                            : withdrawal.permission_for_request === 1
                              ? "Approved"
                              : "Rejected"}
                        </td>
                        <td>
                          {withdrawal.reasonForPermission}
                        </td>
                        {/* Format the date */}
                        <td>
                          {withdrawal.timestamp
                            ? new Date(withdrawal.timestamp).toLocaleString() // Formats to a default readable format
                            : "N/A"}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center p-5">
                        No withdrawal requests yet
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>

              <h5>Request a New Withdrawal</h5>
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="amount">
                  <Form.Label>Amount</Form.Label>
                  <Form.Control
                    type="number"
                    value={amount}
                    onChange={handleAmountChange}
                    placeholder="Enter amount"
                    required
                  />
                </Form.Group>
                {error && <div className="text-danger">{error}</div>}
                <Button type="submit" className="mt-3">
                  Submit Request
                </Button>
              </Form>
            </div>
          )}
        </div>
      </div>
      <Modal show={showActionModal} onHide={() => setShowActionModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {actionType === "approve" ? "Approve" : "Reject"} Withdrawal
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Are you sure you want to <strong>{actionType}</strong> this
            withdrawal request?
          </p>
          <Form.Group>
            <Form.Label>Comment / Reason</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter reason for this action..."
              value={actionComment}
              onChange={(e) => setActionComment(e.target.value)}
              required={actionType === "reject"} // Optional: make it required for rejection
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowActionModal(false)}>
            Cancel
          </Button>
          <Button
            variant={actionType === "approve" ? "success" : "danger"}
            onClick={handleActionSubmit}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer />
    </div>
  );
};

export default WithDrawal;
